// Destination index for the OnHuman Navigator.
//
// Bundled as a module rather than fetched: the whole thing is a few KB, so
// shipping it with the app removes a network round-trip and lets the first
// keystroke search instantly. (It replaces public/site-index.json, which
// carried 384-dim embeddings per page and weighed ~98KB.)
//
// `terms` is where search accuracy actually comes from: the words real people
// type, including misspellings and colloquial forms, not just the words that
// happen to appear in the page title.

const pages = [
  {
    id: "anamenu",
    href: "/anamenu",
    group: "company",
    tr: {
      title: "Ana Menü",
      description: "OnHuman Ana Menü. Hızlı bağlantılar ve genel bakış.",
      terms: [
        "ana menü", "ana sayfa", "anasayfa", "genel bakış", "başlangıç",
        "site", "menü", "giriş sayfası", "onhuman",
      ],
    },
    en: {
      title: "Main Menu",
      description: "The OnHuman main page. Quick links and an overview.",
      terms: ["main menu", "home", "homepage", "overview", "start", "site", "onhuman"],
    },
  },
  {
    id: "hizmetlerim",
    href: "/hizmetlerim",
    group: "services",
    tr: {
      title: "Hizmetlerim",
      description: "İK danışmanlığı, işe alım, onboarding ve işveren hizmetleri.",
      // Conversational templates ("ne yapıyorsunuz") are deliberately absent:
      // they match any question and drown out the discriminating keyword.
      terms: [
        "hizmetler", "hizmet", "hizmetleriniz", "ik", "insan kaynakları",
        "danışmanlık", "danışman", "işe alım", "ise alim",
        "onboarding", "oryantasyon", "çözümler",
      ],
    },
    en: {
      title: "Services",
      description: "HR consultancy, recruitment, onboarding and employer services.",
      terms: [
        "services", "hr", "human resources", "consultancy", "consulting",
        "recruitment", "hiring", "onboarding", "solutions",
      ],
    },
  },
  {
    id: "adayhizmetlerim",
    href: "/adayhizmetlerim",
    group: "candidate",
    tr: {
      title: "Aday Hizmetlerim",
      description: "CV iyileştirme, mülakat koçluğu, kariyer yönlendirme.",
      terms: [
        "aday", "adayım", "cv", "özgeçmiş", "ozgecmis", "cv hazırlama", "cv koçluğu",
        "cv inceleme", "mülakat", "mulakat", "mülakat hazırlığı", "interview",
        "kariyer", "kariyer koçluğu", "kariyer danışmanlığı", "iş arıyorum",
        "is ariyorum", "iş bulmak", "işe girmek", "linkedin", "kişisel marka",
        "başvuru", "staj",
      ],
    },
    en: {
      title: "Candidate Services",
      description: "CV review, interview coaching and career guidance.",
      terms: [
        "candidate", "cv", "resume", "cv coaching", "cv review", "interview",
        "interview coaching", "career", "career coaching", "job", "looking for a job",
        "job search", "linkedin", "personal brand", "application", "internship",
      ],
    },
  },
  {
    id: "isverenhizmetlerim",
    href: "/isverenhizmetlerim",
    group: "employer",
    tr: {
      title: "İşveren Hizmetlerim",
      description: "Pozisyon tanımı, aday havuzu, onboarding tasarımı.",
      terms: [
        "işveren", "isveren", "işverenim", "şirket", "sirket", "firma", "kurum",
        "pozisyon", "pozisyon tanımı", "aday havuzu", "personel", "eleman",
        "eleman arıyorum", "eleman alımı", "işe alım yapmak", "ekip", "ekibimi büyütmek",
        "yönetici arama", "headhunting", "kadro", "istihdam", "insan kaynağı",
      ],
    },
    en: {
      title: "Employer Services",
      description: "Role definition, candidate pools and onboarding design.",
      terms: [
        "employer", "company", "business", "hiring", "recruit", "role definition",
        "candidate pool", "staff", "team", "grow my team", "executive search",
        "headhunting", "talent", "workforce",
      ],
    },
  },
  {
    id: "hakkimda",
    href: "/hakkimda",
    group: "company",
    tr: {
      title: "Hakkımda",
      description: "Ben kimim, deneyimlerim ve değerlerim.",
      terms: [
        "hakkımda", "hakkımızda", "hakkınızda", "kimsiniz", "biz kimiz",
        "deneyim", "tecrübe", "geçmiş", "referans", "kurucu", "ekip",
      ],
    },
    en: {
      title: "About",
      description: "Who I am, my experience and my values.",
      terms: ["about", "about us", "who are you", "experience", "background", "founder", "story"],
    },
  },
  {
    id: "calismailkelerim",
    href: "/calismailkelerim",
    group: "company",
    tr: {
      title: "Çalışma İlkelerim",
      description: "İş birliği ve danışmanlık yaklaşımımın temel ilkeleri.",
      terms: [
        "çalışma ilkeleri", "calisma ilkeleri", "ilkeler", "yaklaşım", "değerler",
        "prensip", "nasıl çalışıyorsunuz", "iş birliği", "etik", "süreç",
      ],
    },
    en: {
      title: "Working Principles",
      description: "The principles behind how I collaborate and advise.",
      terms: ["principles", "values", "approach", "how do you work", "process", "ethics", "collaboration"],
    },
  },
  {
    id: "iletisim",
    href: "/iletisim",
    group: "contact",
    tr: {
      title: "İletişim",
      description: "Demo, teklif veya destek için iletişime geçin.",
      terms: [
        "iletişim", "iletisim", "iletişime geçmek", "bize ulaşın", "ulaşmak",
        "telefon", "mail", "e-posta", "eposta", "adres", "randevu", "görüşme",
        "teklif", "fiyat", "ücret", "destek", "demo", "soru sormak", "danışmak",
      ],
    },
    en: {
      title: "Contact",
      description: "Get in touch for a demo, a quote or support.",
      terms: [
        "contact", "get in touch", "reach you", "phone", "mail", "email", "address",
        "appointment", "meeting", "quote", "price", "pricing", "cost", "support", "demo",
      ],
    },
  },
  {
    id: "giris",
    href: "/giris",
    group: "contact",
    tr: {
      title: "Giriş",
      description: "Kayıtlı kullanıcılar için panel girişi.",
      terms: [
        "giriş", "giris", "giriş yap", "oturum", "login", "hesap", "panel",
        "şifre", "kullanıcı", "üye girişi",
      ],
    },
    en: {
      title: "Sign in",
      description: "Panel access for registered users.",
      terms: ["sign in", "login", "log in", "account", "panel", "password", "user", "dashboard"],
    },
  },
];

// Flattened per-locale view: what the search actually indexes.
export function getPages(locale = "tr") {
  const lang = locale === "en" ? "en" : "tr";
  return pages.map((p) => ({
    id: `${p.id}-${lang}`,
    href: p.href,
    group: p.group,
    title: p[lang].title,
    description: p[lang].description,
    terms: p[lang].terms,
  }));
}

export default pages;
